import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import LegalbirdCall from "../../TwilioVoice/LegalbirdCall";
import { useCall } from "../../../provider/CallProvider";
import CaseCallDialer from "../../TwilioVoice/CaseCallDialer";
import CaseCallDocumentation from "../../PhoneCalls/CaseCallDocumentation";
import Softphone from "../../TwilioVoice/Softphone";

type CallModalProps = {
  open: boolean;
  handleClose: () => void;
};

function CallModal({ open, handleClose }: CallModalProps) {
  const { call, isConnecting, calendlyEvent, callProduct, caseCallToDocumentId } = useCall();
  if (!callProduct) {
    return null;
  }
  return (
    <LegalbirdIoModal handleClose={handleClose} open={open} title={caseCallToDocumentId ? "Telefonat dokumentieren" : "Anrufen"}
      disableBackdropClick hideCloseButton cancelButtonLabel={call || isConnecting ? "Minimieren" : "Schließen"}
      keepMounted={call !== null || isConnecting}>
      {!caseCallToDocumentId && (
        <LegalbirdCall>
          {calendlyEvent
            ? <Softphone product={callProduct} calendlyEvent={calendlyEvent} />
            : <CaseCallDialer key={callProduct.id} />}
        </LegalbirdCall>
      )}
      {caseCallToDocumentId && <CaseCallDocumentation key={caseCallToDocumentId} phoneCallId={caseCallToDocumentId} onClose={handleClose} />}
    </LegalbirdIoModal>
  );
}

export default CallModal;
